import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RmaUrlsService } from '@rma/generic/util/environment';
import { Observable } from 'rxjs';

export interface LocationFooterLink {
  name: string;

  sales: LocationFooterLinkUrl;
  finance: LocationFooterLinkUrl;
  leasing: LocationFooterLinkUrl;
}

export interface LocationFooterLinkUrl {
  agentUrl?: string;
  agencyUrl?: string;
}

@Injectable({
  providedIn: 'root',
})
export class FooterApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaUrls = inject(RmaUrlsService);

  public getLocationFooterLinks(): Observable<LocationFooterLink[]> {
    const url = this.rmaUrls.apiUrl('v1/Layout/FooterLinks');
    return this.httpClient.get<LocationFooterLink[]>(url);
  }
}
